import React from 'react';

import { isEmpty } from 'lodash';
import { faCircleExclamation } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Form as ShadcnForm,
  FormDescription,
  FormItem,
  FormLabel,
} from '@/components/ui/form';
import { Alert } from '../../../../shared/components/Alert';
import {
  CheckboxField,
  InputField,
  SubmitButton,
  TextareaField,
} from '../../../../shared/components/Form';
import { ERROR_TITLES } from './constants';
import { useForm } from './hooks';

const DELIVERY_CHANNELS = [
  {
    label: 'Email',
    name: 'sendEmail',
  },
  {
    label: 'SMS',
    name: 'sendSms',
  },
];

const Form = () => {
  const { errorMessage, form, handleSubmit, isLoading } = useForm();

  return (
    <ShadcnForm {...form}>
      <form className="space-y-4" onSubmit={form.handleSubmit(handleSubmit)}>
        <InputField
          control={form.control}
          label="Subject"
          name="subject"
          placeholder="Enter a subject"
        />

        <InputField
          control={form.control}
          label="Title"
          name="title"
          placeholder="Enter a title"
        />

        <TextareaField
          control={form.control}
          label="Content"
          name="content"
          placeholder="Enter content"
        />

        <InputField
          control={form.control}
          label="Confirmation Message"
          name="confirmationMessage"
          placeholder="Enter a confirmation message"
        />

        <FormItem>
          <div className="mb-4">
            <FormLabel className="text-base">Delivery</FormLabel>

            <FormDescription>
              Select the means of delivery for your review request.
            </FormDescription>
          </div>

          {DELIVERY_CHANNELS.map((option) => (
            <CheckboxField
              key={option.name}
              control={form.control}
              label={option.label}
              name={option.name}
            />
          ))}
        </FormItem>

        {!isEmpty(errorMessage) && (
          <Alert
            description={errorMessage}
            icon={<FontAwesomeIcon icon={faCircleExclamation} />}
            title={ERROR_TITLES.settings.update}
            variant="destructive"
          />
        )}

        <SubmitButton isLoading={isLoading}>Save</SubmitButton>
      </form>
    </ShadcnForm>
  );
};

export default Form;
